import { INote } from "../../../types/notes";
import { dateToString } from "../../../utils/dateToString";

export const notes: INote[] = [
  {
    id: "1",
    title: "First task",
    content: "First task",
    created_at: dateToString(new Date()),
    category: "Task",
    dates: "",
    archived: false,
  },
  {
    id: "2",
    title: "2 task",
    content: "Second task",
    created_at: dateToString(new Date()),
    category: "Task",
    dates: "",
    archived: false,
  },
  {
    id: "3",
    title: "3 task",
    content: "Third task",
    created_at: dateToString(new Date()),
    category: "Task",
    dates: "",
    archived: false,
  },
  {
    id: "4",
    title: "Thought",
    content: "Thought",
    created_at: dateToString(new Date()),
    category: "Random Thought",
    dates: "",
    archived: false,
  },
  {
    id: "5",
    title: "1 idea",
    content: "First idea 1/1/2024, second time 1/2/2024",
    created_at: dateToString(new Date()),
    category: "Idea",
    dates: "1/1/2024,1/2/2024",
    archived: false,
  },
  {
    id: "6",
    title: "2 idea",
    content: "Second idea",
    created_at: dateToString(new Date()),
    category: "Idea",
    dates: "",
    archived: false,
  },
  {
    id: "7",
    title: "3 idea",
    content: "Last idea",
    created_at: dateToString(new Date()),
    category: "Idea",
    dates: "",
    archived: false,
  },
];
